import { o as onMount, a as onDestroy, l as listen, b as bubble, c as current_component, S as SvelteComponent, i as init, s as safe_not_equal, d as assign, e as element, f as set_attributes, g as insert, n as noop, h as detach, j as afterUpdate, k as exclude_internal_props, m as binding_callbacks, p as create_component, q as mount_component, r as get_spread_update, t as get_spread_object, u as transition_in, v as transition_out, w as destroy_component, x as bind, y as add_flush_callback } from './common/index-53439eb3.js';
import { C as Chart$1, d as BarController } from './common/chart-793576c6.js';

const eventPrefix = /^on/;
const events = [];
Object.keys(globalThis).forEach(key => {
    if (eventPrefix.test(key)) {
        events.push(key.replace(eventPrefix, ''));
    }
});
function useForwardEvents(getRef) {
    const component = current_component;
    const destructors = [];
    function forward(e) {
        bubble(component, e);
    }
    onMount(() => {
        const ref = getRef();
        events.forEach(ref instanceof Element
            ? event => destructors.push(listen(ref, event, forward))
            : event => destructors.push(ref.$on(event, forward)));
    });
    onDestroy(() => {
        while (destructors.length) {
            destructors.pop()();
        }
    });
}

/* node_modules/svelte-chartjs/Chart.svelte generated by Svelte v3.57.0 */

function create_fragment(ctx) {
	let canvas;
	let canvas_levels = [/*props*/ ctx[1]];
	let canvas_data = {};

	for (let i = 0; i < canvas_levels.length; i += 1) {
		canvas_data = assign(canvas_data, canvas_levels[i]);
	}

	return {
		c() {
			canvas = element("canvas");
			set_attributes(canvas, canvas_data);
		},
		m(target, anchor) {
			insert(target, canvas, anchor);
			/*canvas_binding*/ ctx[8](canvas);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(canvas);
			/*canvas_binding*/ ctx[8](null);
		}
	};
}

function clean(props) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	let { data, type, options, plugins, children, $$scope, $$slots, ...rest } = props;

	return rest;
}

function instance($$self, $$props, $$invalidate) {
	let { type } = $$props;
	let { data = { datasets: [] } } = $$props;
	let { options = {} } = $$props;
	let { plugins = [] } = $$props;
	let { updateMode = undefined } = $$props;
	let { chart = null } = $$props;
	let canvasRef;
	let props = clean($$props);

	onMount(() => {
		$$invalidate(2, chart = new Chart$1(canvasRef, { type, data, options, plugins }));
	});

	afterUpdate(() => {
		if (!chart) return;
		$$invalidate(2, chart.data = data, chart);
		Object.assign(chart.options, options);
		chart.update(updateMode);
	});

	onDestroy(() => {
		if (chart) chart.destroy();
		$$invalidate(2, chart = null);
	});

	useForwardEvents(() => canvasRef);

	function canvas_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			canvasRef = $$value;
			$$invalidate(0, canvasRef);
		});
	}

	$$self.$$set = $$new_props => {
		$$invalidate(9, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
		if ('type' in $$new_props) $$invalidate(3, type = $$new_props.type);
		if ('data' in $$new_props) $$invalidate(4, data = $$new_props.data);
		if ('options' in $$new_props) $$invalidate(5, options = $$new_props.options);
		if ('plugins' in $$new_props) $$invalidate(6, plugins = $$new_props.plugins);
		if ('updateMode' in $$new_props) $$invalidate(7, updateMode = $$new_props.updateMode);
		if ('chart' in $$new_props) $$invalidate(2, chart = $$new_props.chart);
	};

	$$props = exclude_internal_props($$props);

	return [
		canvasRef,
		props,
		chart,
		type,
		data,
		options,
		plugins,
		updateMode,
		canvas_binding
	];
}

class Chart extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			type: 3,
			data: 4,
			options: 5,
			plugins: 6,
			updateMode: 7,
			chart: 2
		});
	}
}

/* node_modules/svelte-chartjs/Bar.svelte generated by Svelte v3.57.0 */

function create_fragment$1(ctx) {
	let chart_1;
	let updating_chart;
	let current;
	const chart_1_spread_levels = [{ type: "bar" }, /*props*/ ctx[1]];

	function chart_1_chart_binding(value) {
		/*chart_1_chart_binding*/ ctx[4](value);
	}

	let chart_1_props = {};

	for (let i = 0; i < chart_1_spread_levels.length; i += 1) {
		chart_1_props = assign(chart_1_props, chart_1_spread_levels[i]);
	}

	if (/*chart*/ ctx[0] !== void 0) {
		chart_1_props.chart = /*chart*/ ctx[0];
	}

	chart_1 = new Chart({ props: chart_1_props });
	/*chart_1_binding*/ ctx[3](chart_1);
	binding_callbacks.push(() => bind(chart_1, 'chart', chart_1_chart_binding));

	return {
		c() {
			create_component(chart_1.$$.fragment);
		},
		m(target, anchor) {
			mount_component(chart_1, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const chart_1_changes = (dirty & /*props*/ 2)
			? get_spread_update(chart_1_spread_levels, [chart_1_spread_levels[0], get_spread_object(/*props*/ ctx[1])])
			: {};

			if (!updating_chart && dirty & /*chart*/ 1) {
				updating_chart = true;
				chart_1_changes.chart = /*chart*/ ctx[0];
				add_flush_callback(() => updating_chart = false);
			}

			chart_1.$set(chart_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(chart_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(chart_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			/*chart_1_binding*/ ctx[3](null);
			destroy_component(chart_1, detaching);
		}
	};
}

function instance$1($$self, $$props, $$invalidate) {
	Chart$1.register(BarController);
	let { chart = null } = $$props;
	let props;
	let baseChartRef;
	useForwardEvents(() => baseChartRef);

	function chart_1_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			baseChartRef = $$value;
			$$invalidate(2, baseChartRef);
		});
	}

	function chart_1_chart_binding(value) {
		chart = value;
		$$invalidate(0, chart);
	}

	$$self.$$set = $$new_props => {
		$$invalidate(5, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
		if ('chart' in $$new_props) $$invalidate(0, chart = $$new_props.chart);
	};

	$$self.$$.update = () => {
		 $$invalidate(1, props = $$props);
	};

	$$props = exclude_internal_props($$props);
	return [chart, props, baseChartRef, chart_1_binding, chart_1_chart_binding];
}

class Bar extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance$1, create_fragment$1, safe_not_equal, { chart: 0 });
	}
}

export { Bar };
